import { v4 as uuidv4 } from 'uuid';
export class EngagementActivityNoteModel {
    constructor() {
        this.id = uuidv4();
        this.activityId = null;
        this.notes = '';
    }
}
export default class EngagementActivityNote extends EngagementActivityNoteModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
